/**
 * @fileoverview Arquivo responsável por registrar as rotas da aplicação e compor seus providers principais.
 */

import React from "react";
import { BrowserRouter, Switch, Route as RouterRoute, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import SettingsCustom from "../pages/SettingsCustom/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import Helps from "../pages/Helps/";
import Companies from "../pages/Companies/";
import QuickMessages from "../pages/QuickMessages/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import Annoucements from "../pages/Annoucements";
import ToDoList from "../pages/ToDoList/";
import Files from "../pages/Files/";
import ForgetPassword from "../pages/ForgetPassWord/"; // Reset PassWd
import SuperDashboard from "../pages/SuperDashboard";
import SuperAdminPanel from "../pages/SuperAdminPanel";
import ExternalLeads from "../pages/ExternalLeads";
import Fluxo from "../pages/Fluxo";
import FlowBuilder from "../pages/Fluxo/FlowBuilder";
import InternalChat from "../pages/InternalChat";
import InternalChatInvite from "../pages/InternalChat/Invite";
import NewsPosts from "../pages/NewsPosts";
import MetaTemplates from "../pages/MetaTemplates";
import Integrations from "../pages/Integrations";
import MultiUnidades from "../pages/MultiUnidades";
import Academy from "../pages/Academy";
import AcademyCourse from "../pages/Academy/Course";
import AcademyManage from "../pages/AcademyManage";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/forgetpsw" component={ForgetPassword} />
            <RouterRoute exact path="/internal-chat/invite/:token" component={InternalChatInvite} />
            {/* <Route exact path="/create-company" component={Companies} /> */}
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                {/* Rota legada: Dashboard Geral foi unificado dentro de
                    Multi unidades > sub-aba "Graficos operacionais".
                    Redireciona para preservar bookmarks existentes. */}
                <RouterRoute exact path="/dashboard-geral">
                  <Redirect to="/multi-unidades?tab=charts" />
                </RouterRoute>
                <Route
                  exact
                  path="/super-dashboard"
                  component={SuperDashboard}
                  isPrivate
                />
                <Route
                  exact
                  path="/super-admin-panel"
                  component={SuperAdminPanel}
                  isPrivate
                />
                <Route
                  exact
                  path="/tickets/:ticketId?"
                  component={TicketResponsiveContainer}
                  isPrivate
                />
                <Route
                  exact
                  path="/connections"
                  component={Connections}
                  isPrivate
                />
                <Route
                  exact
                  path="/quick-messages"
                  component={QuickMessages}
                  isPrivate
                />
                <Route exact path="/todolist" component={ToDoList} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/files" component={Files} isPrivate />
                <Route
                  exact
                  path="/settings"
                  component={SettingsCustom}
                  isPrivate
                />
                <Route
                  exact
                  path="/companies"
                  component={Companies}
                  isPrivate
                />
                <Route exact path="/queues" component={Queues} isPrivate />
                <Route
                  exact
                  path="/announcements"
                  component={Annoucements}
                  isPrivate
                />
                <Route
                  exact
                  path="/crm"
                  component={ExternalLeads}
                  isPrivate
                />
                <Route exact path="/fluxo" component={Fluxo} isPrivate />
                <Route exact path="/fluxo/:id" component={FlowBuilder} isPrivate />
                <Route exact path="/integrations" component={Integrations} isPrivate />
                <Route exact path="/internal-chat/:channelId?" component={InternalChat} isPrivate />
                <Route exact path="/news-posts" component={NewsPosts} isPrivate />
                <Route
                  exact
                  path="/meta-templates"
                  component={MetaTemplates}
                  isPrivate
                />
                <Route
                  exact
                  path="/multi-unidades"
                  component={MultiUnidades}
                  isPrivate
                />
                <Route exact path="/academy" component={Academy} isPrivate />
                <Route
                  exact
                  path="/academy/courses/:id"
                  component={AcademyCourse}
                  isPrivate
                />
                <Route
                  exact
                  path="/academy/manage"
                  component={AcademyManage}
                  isPrivate
                />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer
            autoClose={5000}
            hideProgressBar
            newestOnTop
            closeOnClick
            pauseOnHover={false}
            pauseOnFocusLoss={false}
            draggable={false}
          />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
